module.exports = __webpack_public_path__ + "img/Haus,  Wohnen & Garten.e5aa88c3.jpg";